import React from "react";
import Table from "../../common-components/table/table";
import { getTableData } from "./helpers";
import { IGetUnpaidInvoicesData } from "../../../../../services/ClientsDashboardServices.dto";

const UnpaidTable = ({ data }: { data: IGetUnpaidInvoicesData[] }) => {
  const { headRow, bodyRows } = getTableData(data);

  return <Table headRow={headRow} bodyRows={bodyRows} className="small sticky-header" />;
};

export default UnpaidTable;
